import Vue from "vue";
import store from "./store";
import router from "./router";
import variables from "@/styles/element-variables.scss";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { Message } from "element-ui";
import { permissionMenu } from "@/utils/menu";
import { registerSubApps, actions } from "./qiankun";

const routerState = (function () {
  let to = {},
    from = {},
    next = {},
    _prviate = {}, // 私有变量
    _currentState = {}; // 状态私有变量

  /** 内部方法
   *  documentTitle：设置主应用浏览器标题
   * siteConfig：获取网站配置信息（主题、底部信息、系统名称等）
   * updateUserInfo：更新用户信息
   * getInitMainAppPermission：获取初始化权限
   * fromPathSignMountApp：从登录页来，特殊处理
   * signMountApp：登录处理
   * noPermission：没有权限处理方法
   */
  const state = {
    // 设置主应用浏览器标题
    documentTitle() {
      if (to.meta.title && to.path.indexOf("subview") == -1 && to.path.indexOf("signMountApp") == -1) {
        window.document.title = to.meta.title;
      }
    },

    // 判断网站配置信息（主题等）
    siteConfig(fn) {
      if (!_prviate.websiteConf) {
        Vue.prototype.$getWebsite().then((websiteConfig) => {
          _prviate.websiteConf = websiteConfig;
          Vue.prototype.$setThemeColor(websiteConfig.window.themeColor, variables.colorPrimary.toLowerCase()).then(() => {
            store.dispatch("setWebsiteConfig", websiteConfig).then(() => {
              fn && fn(to, from, next);
            });
          });
        });
      } else {
        fn && fn(to, from, next);
      }
    },

    // 更新用户信息
    updateUserInfo() {
      if (!store.getters.personalInfo.userUuid) {
        // 没有保存个人信息
        store.dispatch("UpdateUserInfo");
      }
    },

    // 获取初始化权限
    getInitMainAppPermission() {
      store
        .dispatch("getUserAcountList", { appCode: "operation" })
        .then(() => {
          Action.match();
        })
        .catch((res) => {
          Action.run("noPermission", res);
        });
    },

    // 从登录页来，特殊处理
    fromPathSignMountApp() {
      if (from.path.indexOf("signMountApp") !== -1) {
        // 解决登录失效问题
        store.commit("CLEAR_ACCOUNTLIST");
        store.dispatch("clearLoginUser");
      }
    },

    // 进入登录
    async signMountApp() {
      // 登录模块未注册先进行注册
      if (!_prviate.signMountAppHasRegister) {
        _prviate.signMountAppHasRegister = true;
        registerSubApps({
          name: "signMountApp",
          container: "#loginsubview",
          activeRule: "#/signMountApp"
        });
      }
      next();
    },

    // 没有权限处理
    noPermission(res) {
      if (res.code != 12) {
        const message = res.message || res.msg;

        Message.error(message);
        setTimeout(() => {
          next("/login");
        }, 5000);
      }
    }
  };

  /** 匹配路由特殊标识的处理
   *  subview：产品服务（子服务为微服务架构）处理函数
   *  serviceweb：老服务（外链方式进入的服务）处理函数
   */
  const routePathMatchObject = {
    // 进入产品服务（微服务架构服务）
    subview() {
      // 微服务产品
      const subappCode = to.path.replace(/\/subview\/([^/]+)\/\S+/g, "$1");

      if (store.getters.subappMenuList.length === 0) {
        // 子应用获取权限
        store
          .dispatch("getUserAcountList", {
            appCode: subappCode
          })
          .then((result) => {
            const { user } = result;
            const subappMenuList = permissionMenu(user.moduleList, subappCode);

            store
              .dispatch("AddSubappInfo", {
                permission: user.moduleList,
                menuList: subappMenuList,
                appCode: subappCode
              })
              .then(() => {
                next();
              });
          });
      } else {
        next();
      }
    },

    // 进入老服务（老服务架构-外链方式）
    serviceweb() {
      store
        .dispatch("getUserAcountList", {
          appCode: to.query.appCode
        })
        .then((result) => {
          next();
        });
    }
  };

  const Action = {
    // 初始化路由相关信息
    init(config) {
      to = config.to || {};
      from = config.from || {};
      next =
        config.next ||
        function () {
          console.log("no next function");
        };
      return this;
    },

    /** 设置执行方法状态
     * 传递的函数名存于state对象中
     * 示例：routerState.setState('a','b').run() // 设置要执行的a,b方法，通过run执行
     */
    setState() {
      const args = arguments; // 组合动作执行，传递多个参数来实现

      _currentState = {}; // 重置内置状态
      if (args.length) {
        for (let i = 0; i < args.length; i++) {
          _currentState[args[i]] = true;
        }
      }
      return this;
    },

    /** 执行状态方法
     * 单独使用示例：
     * routerState.run('functionName','functionParams')
     * 与setState配合使用示例：
     * routerState.setState('a','b').run()
     */
    run(fnName) {
      if (typeof fnName !== "undefined") {
        const args = Array.prototype.slice.call(arguments, 1);

        if (fnName.indexOf(".") !== -1) {
          // 兼容await语法，返回promise
          const fn = fnName.slice(0, fnName.indexOf("."));

          return state[fn] && state[fn].apply(state, args);
        } else {
          state[fnName] && state[fnName].apply(state, args);
        }
        return this;
      }
      for (let i in _currentState) {
        state[i] && state[i]();
      }
      return this;
    },

    // 路由路径匹配特殊标识
    match(fnNameStr) {
      if (typeof fnNameStr !== "undefined") {
        routePathMatchObject[fnNameStr] && routePathMatchObject[fnNameStr]();
        return false;
      }
      let matched = false; // 默认未匹配到标识

      let fnList = Object.keys(routePathMatchObject);

      for (let i = 0, len = fnList.length; i < len; i++) {
        const fnName = fnList[i];

        if (to.path.indexOf(`/${fnName}/`) !== -1) {
          matched = true;
          routePathMatchObject[fnName] && routePathMatchObject[fnName]();
          break;
        }
      }
      if (!matched) {
        next();
      }
    }
  };

  return {
    init: Action.init,
    setState: Action.setState,
    run: Action.run,
    match: Action.match
  };
})();

router.beforeEach((to, from, next) => {
  NProgress.start();
  routerState.init({ to, from, next }).run("documentTitle");
  routerState.run("siteConfig", async function (to, from, next) {
    // from登录来，特殊处理
    routerState.run("fromPathSignMountApp");

    // 在免登录白名单，直接进入
    if (to.meta && to.meta.onWhiteList) {
      next();
    } else if (to.path.indexOf("signMountApp") !== -1) {
      // 登录模块处理
      routerState.run("signMountApp");
    } else {
      // 保存右上角用户信息
      routerState.run("updateUserInfo");
      if (store.getters.acountList.length === 0) {
        // 没有权限，初始化获取权限
        routerState.run("getInitMainAppPermission");
      } else {
        next();
      }
    }
  });
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});



// WEBPACK FOOTER //
// ./src/permission.js